/**
 * Runtime (not build-time) app config, fetched once from `config.json` before
 * the app renders. Lets the same build artifact be deployed to every
 * environment — the deploy pipeline overwrites `config.json` per environment
 * instead of baking values into the bundle via `VITE_*` at build time.
 */
interface RuntimeConfig {
  allowedOrigins: string[];
  allowAllOrigins: boolean;
}

const DEFAULT_CONFIG: RuntimeConfig = { allowedOrigins: [], allowAllOrigins: false };

let config: RuntimeConfig = DEFAULT_CONFIG;

/** Fetches and caches `config.json`. Falls back to defaults if it's missing or invalid. */
export async function loadRuntimeConfig(): Promise<void> {
  try {
    const res = await fetch(`${import.meta.env.BASE_URL}config.json`, { cache: 'no-store' });
    if (!res.ok) return;
    const data = await res.json();
    const origins: string[] = Array.isArray(data?.allowedOrigins)
      ? data.allowedOrigins.filter((o: unknown): o is string => typeof o === 'string')
      : [];
    config = {
      allowedOrigins: origins.filter((o) => o !== '*'),
      allowAllOrigins: origins.includes('*'),
    };
  } catch {
    // Network error or malformed JSON — keep the safe defaults.
  }
}

export function getRuntimeConfig(): RuntimeConfig {
  return config;
}
